/* eslint-disable import/prefer-default-export */
import { apiCaller } from 'util/apiCaller';

const fetchDanhMuc = function* fetchDanhMucHuyen() {
  const configAPI = {
    url: 'api/danhmuchuyens',
    method: 'GET',
    params: {
      maTinh: 49
    },
    isShowMessage: false
  };
  const data = apiCaller(configAPI);
  return yield data || [];
};

const fetchDanhMucById = function* fetchDanhMucById(maDonVi) {
  const configAPI = {
    url: 'api/dmdc/donvihanhchinh',
    method: 'GET',
    params: {
      madonvi: maDonVi
    },
    isShowMessage: false
  };
  const data = apiCaller(configAPI);
  return yield data || [];
};

export const danhMucDungChungAPI = {
  fetchDanhMuc,
  fetchDanhMucById
};
